Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedTextView extends Backbone.View
  template: JST['backbone/templates/monitoring/filters/applied_text']
  className: 'user'
  events:
    'click div.user_being_applied a.remove': 'removeText'

  initialize: ({searchQuery, title, fieldName}) =>
    @searchQuery = searchQuery
    @title = title
    @fieldName = fieldName || 'text'

  destroy: =>
    @remove()
    false

  render: =>
    @$el.html(@template(
      searchQuery: @searchQuery
      title: @title
      fieldName: @fieldName
    ))
    @$el.find('a.remove, a.remove-filters').attr('style', 'display: inline')
    @

  removeText: (event) =>
    text = $(event.target).parent().find('.user').text()
    @searchQuery.removeText(text)
    @_triggerQueryChanged()

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
